import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calcul du pourcentage pondéré";
const DESCRIPTION =
  "Calcul du pourcentage pondéré pour suivre vos notes, moyennes et conversions scolaires avec precision. Outil utile pour planifier vos objectifs et mieux piloter votre progression academique.";
const KEYWORDS =
  "calcul du pourcentage pondéré, calculatrice calcul du pourcentage pondéré, calcul en ligne, etudes, notes, GPA, resultat rapide";
const OG_URL =
  "https://do-calculate.com/calculator/fr/weighted-percentage-calculator/";
function WeightedPercentageCalculator() {
  const [secondaryGrade, setSecondaryGrade] = useState();
  const [aptitudeScore, setAptitudeScore] = useState();
  const [achievementScore, setAchievementScore] = useState();
  const [result, setResult] = useState();
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      let weightedPercentage = 0;
      if (secondaryGrade && aptitudeScore && achievementScore) {
        weightedPercentage =
          secondaryGrade * 0.3 + aptitudeScore * 0.3 + achievementScore * 0.4;
      } else if (secondaryGrade && aptitudeScore) {
        weightedPercentage = secondaryGrade * 0.6 + aptitudeScore * 0.4;
      }
      setResult(weightedPercentage.toFixed(2));
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>Cette calculatrice calcule le pourcentage pondéré en fonction de:</p>
                <ul>
                  <li>GPA cumulatif du secondaire</li>
                  <li>Score de capacité</li>
                  <li>Score de rendement (s'il y a lieu)</li>
                </ul>
                <p>Les formules suivantes sont appliquées pour calculer le pourcentage pondéré:</p>
                <ul>
                  <li>
                    (GPA cumulatif du secondaire × 30%) + (Score de capacité × 30%) + (Score de rendement × 40%)
                  </li>
                  <li>
                    (GPA cumulatif du secondaire × 50%) + (Score de capacité × 20%) + (Score de rendement × 30%)
                  </li>
                  <li>
                    (GPA cumulatif du secondaire × 60%) + (Score de capacité × 40%)
                  </li>
                </ul>
                <hr />
              </div>
              <br />
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="ltr">
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2">
                        GPA cumulatif du secondaire
                      </label>
                      <input
                        id="secondaryGrade"
                        type="number"
                        value={secondaryGrade}
                        onChange={(e) => setSecondaryGrade(parseFloat(e.target.value))}
                        className="form-control"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">Score de capacité</label>
                      <input
                        id="aptitudeScore"
                        type="number"
                        value={aptitudeScore}
                        onChange={(e) => setAptitudeScore(parseFloat(e.target.value))}
                        className="form-control"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Score de rendement (optionnel)
                      </label>
                      <input
                        id="achievementScore"
                        type="number"
                        value={achievementScore}
                        onChange={(e) => setAchievementScore(parseFloat(e.target.value))}
                        className="form-control"
                      />
                    </div>
                    <button
                      className="btn btn-success"
                      type="button"
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-7">
                <br />
                {error && (
                  <div className="alert alert-danger">
                    <strong>Erreur:</strong> {error}
                  </div>
                )}
                {result && (
                  <div className="bg-light bg-gradient text-dark">
                    <div className="p-3 mb-2 bg-success bg-gradient text-white">
                      <strong>Résultat</strong>
                    </div>
                    <b>Pourcentage pondéré:</b> {result}%
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
    </div>
  );
}
export default WeightedPercentageCalculator;
